<div class="icon-align">
  <mat-icon class="icon-space" matTooltip="Primary Capability"> work </mat-icon>

  <span class="capability-text">
    {{ capabilityName }}
  </span>
</div>
